export const MuiTabs = {
  styleOverrides: {
    root: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      minHeight: 'fit-content',
      mr: '3rem',
    },
    indicator: {
      mb: '4rem',
      top: 0,
      height: '0.4rem',
      backgroundColor: '#1010eb',
      transition: 'none',
    },
  },
};
